const DEFAULT_INTERVAL_MS = 60_000;

export interface IRateLimitedLogger {
  warn(key: string, message: string, intervalMs?: number): void;
}

interface IRateLimitedLoggerInternal extends IRateLimitedLogger {
  _resetForTests(): void;
}

const _lastEmittedAt = new Map<string, number>();

export const RateLimitedLogger: IRateLimitedLoggerInternal = {
  /**
   * Emit a `console.warn` for a given key, suppressing repeats within `intervalMs`.
   * @param key - Stable identifier per warning site; rate-limit state is tracked per key.
   * @param message - The message to log via `console.warn`.
   * @param intervalMs - Minimum interval between emissions for the same key (default 60s).
   */
  warn(key: string, message: string, intervalMs: number = DEFAULT_INTERVAL_MS): void {
    const now = Date.now();
    const last = _lastEmittedAt.get(key) ?? -Infinity;
    if (now - last >= intervalMs) {
      _lastEmittedAt.set(key, now);
      console.warn(message);
    }
  },
  /** Test-only: reset all rate-limit state. Production code must never call this. */
  _resetForTests(): void {
    _lastEmittedAt.clear();
  }
};
